import { render } from "./CerrarSession.vue?vue&type=template&id=e1a255c6"
import script from "./CerrarSession.vue?vue&type=script&lang=js"
export * from "./CerrarSession.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__